import { render } from "./FashionListItem.vue?vue&type=template&id=34878dce&scoped=true&ts=true"
import script from "./FashionListItem.vue?vue&type=script&lang=ts"
export * from "./FashionListItem.vue?vue&type=script&lang=ts"

import "./FashionListItem.vue?vue&type=style&index=0&id=34878dce&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34878dce"]])

export default __exports__